import type { LucideIcon } from "lucide-react";
import { SlidersHorizontal, User } from "lucide-react";

interface ProfileNavItem {
  key: string;
  label: string;
  icon: LucideIcon;
}

/** Left-nav entries for the `/profile` page, in display order. */
export const PROFILE_NAV_ITEMS = [
  { key: "profile", label: "Profile", icon: User },
  { key: "preferences", label: "Export Defaults", icon: SlidersHorizontal },
] as const satisfies readonly ProfileNavItem[];

/**
 * Tab keys shared between ProfilePage (container) and ProfilePageView (presenter). Derived
 * from PROFILE_NAV_ITEMS so the nav array is the single source of truth — a key with no nav
 * entry can't exist, and vice versa.
 */
export type ProfileTabKey = (typeof PROFILE_NAV_ITEMS)[number]["key"];
